import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import { FiInfo } from "react-icons/fi"; // Using react-icons
import {
  Heart,
  Menu,
  X,
  User,
  Crown,
  Shield,
  Star,
  Cannabis,
  Languages,
} from "lucide-react";
import { Button } from "./ui/button";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from "./ui/alert-dialog";
import { IoMdNotificationsOutline } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { clearUserState } from "../redux/userSlice";
import { setUserId } from "../redux/userSlice";
import {
  getWithoutTokenAPI,
  getWithTokenAPI,
  postWithTokenAPI,
  putWithTokenAPI,
} from "../util/Api";
import { useLocation, useNavigate } from "react-router-dom";
import { setCurrentPage } from "../redux/navigationSlice.js";
import "../styles/Header.css";
import { Bell, Check, Settings } from "lucide-react";
import { Eye, Clock } from "lucide-react";
import { useTranslation } from "react-i18next";
import "../styles/Header.css";
import { setCompletion } from "../redux/completionSlice.js";
import { Avatar, AvatarImage, AvatarFallback } from "./ui/avatar.jsx";

export const Header = forwardRef(({ update }, ref) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [subpack, setSubsPack] = useState();
  const [viewlimit, setViewLimit] = useState(3);
  const [messagelimit, setMessageLimit] = useState(3);
  const [viewcount, setviewcount] = useState(0);
  const [messcount, setmesscount] = useState(0);
  const data = useSelector((state) => state.user);
  const currentPage = useSelector((state) => state.navigation.currentPage);
  const navigate = useNavigate();
  const token = data?.userId?.accessToken;
  const id = data?.userId?.user?._id;
  const dispatch = useDispatch();
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const [show, setShow] = useState(false);
  const handleLogout = () => {
    setShowLogoutDialog(true);
  };
  const [profileData, setprofileData] = useState("");
  const [header, setHeader] = useState({});
  const [completebar, setCompletebar] = useState(0);
  const completion = useSelector((state) => state.completion.value);
  const [openCompletionDialog, setOpenCompletionDialog] = useState(false);
  const location = useLocation();

  // Replace your existing notification state and effects with:
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  console.log(notifications, "NOTIFICATIONS");
  const dropdownRef = useRef(null);

  const { t, i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState("en");

  const changeLanguage = () => {
    const newLang = currentLang === "en" ? "ta" : "en";
    i18n.changeLanguage(newLang);
    setCurrentLang(newLang);
  };

  useEffect(() => {
    const fetchlimit = async () => {
      try {
        const response = await getWithTokenAPI(token, `/user/stats/${id}`);
        console.log(response, "LIMIT RESPONSE");
        setMessageLimit(response?.data?.daily_message_limit);
        setViewLimit(response?.data?.daily_view_limit);
        setviewcount(response?.data?.unique_profiles_viewed_today);
        setmesscount(response?.data?.unique_profiles_messaged_today);
      } catch {
        console.log("Error in fetching Limit Api");
      }
    };
    fetchlimit();
  }, [token, id]);

  useEffect(() => {
    const fetchAllDetails = async () => {
      try {
        const response = await getWithTokenAPI(
          token,
          `/notification/find-particular?type=user&user_id=${id}&notification_type=notification`
        );

        const getTimeAgo = (dateString) => {
          const now = new Date();
          const created = new Date(dateString);
          const diffInSeconds = Math.floor((now - created) / 1000);

          if (diffInSeconds < 60) return `${diffInSeconds} sec ago`;
          const diffInMinutes = Math.floor(diffInSeconds / 60);
          if (diffInMinutes < 60) return `${diffInMinutes} min ago`;
          const diffInHours = Math.floor(diffInMinutes / 60);
          if (diffInHours < 24)
            return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
          const diffInDays = Math.floor(diffInHours / 24);
          if (diffInDays === 1) return "Yesterday";
          return `${diffInDays} days ago`;
        };

        if (response && Array.isArray(response.data)) {
          const formattedNotifications = response.data.map((item) => ({
            id: item._id,
            title: item.heading || "Notification",
            message: item.content || "No content available",
            time: getTimeAgo(item.createdAt),
            unread: !item.is_read,
          }));

          setNotifications(formattedNotifications);
        } else {
          setNotifications([]);
        }
      } catch (error) {
        console.error("Error fetching notifications:", error);
        setNotifications([]); // fallback
      }
    };

    fetchAllDetails();
  }, [token, id]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Prevent body scroll when notification is open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [open]);

  const unreadCount = notifications.filter((n) => n.unread).length;
  const progress = Math.round((completebar / 4) * 100);
  const markAsRead = async (id) => {
    try {
      setNotifications((prev) =>
        prev.map((n) => (n.id === id ? { ...n, unread: false } : n))
      );
      const response = await putWithTokenAPI(
        token,
        `/notification/update?_id=${id}&is_read=true`
      );
      if (response.statusCode == 200) {
        const path = response.data[0].redirect_path;
        if (path === "/messages") {
          const handleSendMessage = async () => {
            const userid = data?.userId?.user?._id;
            const payload = {
              sender_id: userid,
              receiver_id: response?.data[0].reference_id,
              content: "",
            };

            // rename this response!
            const sendRes = await postWithTokenAPI(
              token,
              `/message/send`,
              payload
            );

            if (sendRes?.statusCode === 200) {
              navigate("/messages");
            }

            if (sendRes?.statusCode === 403) {
              // setSandMeg(true);
            }
          };

          handleSendMessage();
        } else if (path == "/profileViewers") {
          if (progress > 75) {
            return navigate(`/view-profile/${response?.data[0]?.name}`, {
              state: { profileId: response?.data[0].reference_id },
            });
          } else {
            return setOpenCompletionDialog(true);
          }
        } else if (path == "/interests") {
          if (progress > 75) {
            navigate(`/view-profile/${response?.data[0]?.name}`, {
              state: { profileId: response?.data[0].reference_id },
            });
          } else {
            setOpenCompletionDialog(true);
          }
        } else if (path == "/profile") {
          navigate("/profile");
        } else if (path == "/payments") {
          navigate("/subscription");
        }
        // navigate(`/view-profile/:${id}`);
      }
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const markAllAsRead = () => {
    setNotifications(notifications.map((n) => ({ ...n, unread: false })));
  };
  const [profilepic, setProfilepic] = useState("");
  console.log(profilepic, "PROFILEPICTURE");
  const fetchAllDetails = async () => {
    const response = await getWithTokenAPI(token, `/profile/get_all/${id}`);
    if (!response?.data) return;

    const { basicProfile, professionalProfile, preference, zodiac } =
      response.data;
    const weights = {
      basic: 0.5,
      professional: 1.5,
      preference: 1.7,
      zodiac: 0.3,
    };
    setProfilepic(response?.data?.basicProfile?.profileImage);

    let total = 0;
    console.log(total, "TOALPROGRESS");

    if (basicProfile?.Basic_completed) total += weights.basic;
    console.log(total, "TOALPROGRESS");
    if (professionalProfile?.prof_completed) total += weights.professional;
    console.log(total, "TOALPROGRESS");
    if (preference?.pref_completed) total += weights.preference;
    console.log(total, "TOALPROGRESS");

    if (zodiac && zodiac.rasi) {
      const allHouses = Object.values(zodiac.rasi);
      const hasData = allHouses.some((h) => h && h.length > 0);
      if (hasData) total += weights.zodiac;
    }
    console.log(total, "TOALPROGRESS");

    // Set React UI state (0-100)
    setCompletebar(total);
    dispatch(setCompletion(total));
  };

  useEffect(() => {
    fetchAllDetails();
  }, [token, id, update]);

  useImperativeHandle(ref, () => ({
    fetchAllDetails,
  }));

  useEffect(() => {
    const fetchHeader = async () => {
      try {
        const response = await getWithoutTokenAPI(`/header/get_all`);
        if (response?.data?.length) {
          const headerData = response.data[0];
          // Fix the image URL and set header in one call
          const fixedHeader = {
            ...headerData,
            logo: headerData.logo.replace(
              "s3.eu-north-1.amazonaws.com",
              "s3.ap-south-1.amazonaws.com"
            ),
          };
          setHeader(fixedHeader);
        }
      } catch (error) {
        console.error("Error fetching header:", error);
      }
    };
    fetchHeader();
  }, []);
  useEffect(() => {
    if (!id || !token) {
      setprofileData("");
      return;
    }
    const fetchProfile = async () => {
      try {
        const response = await getWithTokenAPI(
          token,
          `/user-id/get_by_id?user_id=${id}`
        );
        setprofileData(response?.data?.profile.name);
        setSubsPack(response?.data?.subscription?.plan_name);
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };
    fetchProfile();
  }, [id, token]);

  const vcount = useSelector((state) => state.profileCount.count);
  console.log(vcount, "  const dispatch = useDispatch()");
  // console.log(useSelector((state)=> state.messagecount.limit),"MESSAGECOUNT");
  const mcount = useSelector((state) => state.messageCount.limit);
  console.log(mcount, "MCOUNT");

  return (
    <header className="avan-avala-header bg-white shadow-sm border-b border-border sticky top-0 z-50">
      <div className="avan-avala-header-container w-8xl mx-auto">
        <div className="avan-avala-header-inner flex justify-between items-center h-16">
          {/* Left Section - Logo (Fixed Width) */}
          <div className="avan-avala-logo-section flex items-center space-x-2 w-56 flex-shrink-0">
            <img
              src={header?.logo}
              alt="logo"
              className="avan-avala-logo w-10 h-10 cursor-pointer"
              onClick={() => navigate("/")}
            />
            <span
              className="avan-avala-logo-text text-xl font-bold cursor-pointer text-red-600 whitespace-nowrap"
              onClick={() => navigate("/")}
            >
              அவன்அவள்
            </span>
            <Button
              variant="ghost"
              size="xs"
              onClick={changeLanguage}
              className="avan-avala-language-btn  items-center space-x-1 text-gray-600 cursor-pointer hover:text-orange-500"
            >
              <Languages className="w-4 h-4" />
              <span className="avan-avala-language-text text-sm font-medium whitespace-nowrap hidden md:flex">
                {currentLang === "en" ? "தமிழ்" : "English"}
              </span>
            </Button>
          </div>

          <div
            style={{
              width: "60%",
              display: "grid",
              gridTemplateColumns: "1fr auto 1fr",
              alignItems: "center",
              // gap: "2rem",
            }}
          >
            {/* Center Section - Desktop Navigation (Flexible but Centered) */}
            <nav
              className="avan-avala-desktop-nav hidden md:flex items-center justify-center space-x-2 flex-1 w-32 mx-2"
              style={{
                gridColumn: "1", // Ensure it stays in the center column
              }}
            >
              <button
                onClick={() => navigate("/browse")}
                className={
                  location.pathname.includes("browse")
                    ? "avan-avala-nav-item active text-orange-500 font-semibold cursor-pointer transition-colors whitespace-nowrap px-3 py-2"
                    : "avan-avala-nav-item text-gray-600 hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap px-3 py-2"
                }
              >
                {t("Browse")}
              </button>

              <button
                onClick={() => {
                  token ? navigate("/matches") : setShowLoginDialog(true);
                }}
                className={
                  location.pathname.includes("matches")
                    ? "avan-avala-nav-item active text-orange-500 font-semibold cursor-pointer transition-colors whitespace-nowrap px-3 py-2"
                    : "avan-avala-nav-item text-gray-600 hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap px-3 py-2"
                }
              >
                {t("Matches")}
              </button>

              <button
                onClick={() => {
                  token ? navigate("/messages") : setShowLoginDialog(true);
                }}
                className={
                  location.pathname.includes("messages")
                    ? "avan-avala-nav-item active text-orange-500 font-semibold cursor-pointer transition-colors whitespace-nowrap px-3 py-2"
                    : "avan-avala-nav-item text-gray-600 hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap px-3 py-2"
                }
              >
                {t("Messages")}
              </button>

              <button
                onClick={() => navigate("/subscription")}
                className="avan-avala-subscription-btn text-purple-600 hover:text-purple-800 transition-colors flex items-center cursor-pointer whitespace-nowrap px-3 py-2"
              >
                <Crown className="w-4 h-4 mr-1 mb-1" />
                {t("Subscription")}
              </button>
            </nav>

            <div
              className="avan-avala-right-section flex items-center justify-evenly w-full md:w-auto"
              style={{
                gridColumn: "4",
                // justifySelf: "end",
              }}
            >
              {token && (
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    margin: "0px 5px",
                  }}
                >
                  <FiInfo
                    size={20}
                    style={{
                      cursor: "pointer",
                      color: "#2563EB",
                      transition: "color 0.3s",
                    }}
                    onMouseEnter={() => setShow(true)}
                    onMouseLeave={() => setShow(false)}
                  />
                  {show && (
                    <div
                      style={{
                        position: "absolute",
                        top: "110%",
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: "200px",
                        marginTop: "8px",
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        padding: "12px",
                        borderRadius: "8px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        zIndex: 10,
                        textAlign: "center",
                      }}
                    >
                      <h3
                        style={{
                          borderBottom: "0.5px solid grey",
                          marginBottom: "7px",
                          fontWeight: "700",
                          color: "maroon",
                          width: "100%",
                          height: "auto",
                        }}
                      >
                        {t("Today")}
                      </h3>
                      <div
                        style={{
                          marginBottom: "6px",
                          fontWeight: "400",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {t("Profile viewed")}{" "}
                        <span style={{ color: "grey" }}>
                          {vcount > 0 ? vcount : viewcount}/{viewlimit}
                        </span>
                      </div>
                      <div
                        style={{
                          fontWeight: "400",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {t("Message count")}{" "}
                        <span style={{ color: "grey" }}>
                          {mcount > 0 ? mcount : messcount}/{messagelimit}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {token && (
                <div className="avan-avala-profile-section hidden md:flex items-center">
                  {completebar !== 4 && (
                    <div
                      className="avan-avala-profile-progress relative flex items-center justify-center cursor-pointer  text-lg"
                      onClick={() => navigate("/profile")}
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <svg
                        className="avan-avala-progress-svg absolute top-0 left-0 mb-1"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                      >
                        <circle
                          cx="16"
                          cy="16"
                          r="14"
                          stroke="#e5e7eb"
                          strokeWidth="3"
                          fill="transparent"
                        />
                        <circle
                          cx="16"
                          cy="16"
                          r="14"
                          stroke="#ef4444"
                          strokeWidth="3"
                          fill="transparent"
                          strokeDasharray={2 * Math.PI * 16}
                          strokeDashoffset={
                            2 * Math.PI * 16 * (1 - completebar / 4)
                          }
                          strokeLinecap="round"
                          className="transition-all duration-500"
                        />
                      </svg>
                      <span className="avan-avala-progress-text text-xs font-semibold text-gray-700 z-10 absolute inset-0 flex items-center justify-center mt-1">
                        {Math.round((completebar / 4) * 100)}%
                      </span>
                    </div>
                  )}
                </div>
              )}
              {/*  */}

              {/* <Button
                    variant="ghost"
                    onClick={() => navigate("/profile")}
                    className="avan-avala-profile-btn hidden md:flex items-center  cursor-pointer"
                  >
                    {subpack === "Elite" ? (
                      <Crown className="w-4 h-4 text-purple-500" />
                    ) : subpack === "Premium" ? (
                      <Star className="w-4 h-4 text-blue-500" />
                    ) : (
                      <User className="w-4 h-4" />
                    )}
                    <span className="avan-avala-profile-name text-md font-medium whitespace-wrap truncate max-w-10 mt-1">
                      {profileData || "Profile"}
                    </span>
                  </Button> */}

              {token && profileData && (
                <div className="avan-avala-mobile-profile-section">
                  {/* <div className="flex items-center space-x-3 border">
                      <div className="flex flex-row justify-between"> */}
                  {/* <span className="text-md text-gray-500">
                          {subpack === "Elite" ? (
                            <Crown className="w-5 h-5 mr-2 text-purple-500" />
                          ) : subpack === "Premium" ? (
                            <Star className="w-5 h-5 mr-2 text-blue-500" />
                          ) : subpack === "gold" || "premium" ? (
                            <Cannabis className="w-5 h-5 mr-2 text-yellow-500" />
                          ) : (
                            <User className="w-5 h-5 mr-2" />
                          )}
                        </span> */}
                  {profileData && (
                    <Avatar className="w-10 h-10 cursor-pointer" onClick={()=>{navigate('/profile')}}>
                      <AvatarImage src={profilepic} alt={"User Avatar"} />
                      <AvatarFallback className="text-center text-xl mt-1">
                        {profileData
                          .split(" ")
                          .map((n) => n[0]?.toUpperCase())
                          .join("")}
                      </AvatarFallback>
                    </Avatar>
                  )}
                  {/* <span
                          className="text-lg font-medium text-gray-700 cursor-pointer"
                          onClick={() => {
                            navigate("/profile");
                            setIsMenuOpen(false);
                          }}
                        >
                          {profileData}
                        </span> */}
                  {/* </div>
                    </div> */}
                </div>
              )}

              <div className="avan-avala-mobile-icons flex items-center">
                {token && (
                  <div
                    className="avan-avala-notification-wrapper relative"
                    ref={dropdownRef}
                  >
                    <button
                      className="avan-avala-notification-btn relative p-1 mt-2 text-gray-600 hover:text-orange-500 transition-colors"
                      onClick={() => setOpen(!open)}
                    >
                      <IoMdNotificationsOutline className="w-6 h-6 cursor-pointer" />
                      {unreadCount > 0 && (
                        <span
                          style={{ padding: "8px" }}
                          className="avan-avala-notification-badge absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center"
                        >
                          {unreadCount > 9 ? "9+" : unreadCount}
                        </span>
                      )}
                    </button>
                  </div>
                )}

                {/* Mobile Menu Button - Always Visible */}
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                  className="avan-avala-mobile-menu-btn flex items-center cursor-pointer p-2"
                >
                  {isMenuOpen ? (
                    <X className="h-5 w-5" />
                  ) : (
                    <Menu className="h-5 w-5" />
                  )}
                </Button>
              </div>

              {/* Login/Logout Button */}
              <Button
                variant={id ? "outline" : "default"}
                className="avan-avala-auth-btn bg-gradient-to-br from-red-500 to-pink-600 text-white sm:hidden cursor-pointer"
                onClick={() => {
                  if (id) {
                    handleLogout();
                  } else {
                    navigate("/login");
                  }
                }}
              >
                {id ? t("Logout") : t("Login")}
              </Button>


            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="avan-avala-mobile-nav md:hidden py-4 border-t border-gray-200 bg-red z-99">
            <nav className="avan-avala-mobile-nav-inner flex flex-col space-y-4">
              <button
                onClick={() => {
                  navigate("/browse");
                  setIsMenuOpen(false);
                }}
                className={`avan-avala-mobile-nav-item cursor-pointer transition-colors text-left py-2 px-4 ${
                  location.pathname.includes("browse")
                    ? "text-orange-500 font-semibold bg-orange-50 rounded-md"
                    : "text-gray-600 hover:text-orange-500"
                }`}
              >
                {t("Browse")}
              </button>

              <button
                onClick={() => {
                  token ? navigate("/matches") : setShowLoginDialog(true);
                  setIsMenuOpen(false);
                }}
                className={`avan-avala-mobile-nav-item cursor-pointer transition-colors text-left py-2 px-4 ${
                  location.pathname.includes("matches")
                    ? "text-orange-500 font-semibold bg-orange-50 rounded-md"
                    : "text-gray-600 hover:text-orange-500"
                }`}
              >
                {t("Matches")}
              </button>

              <button
                onClick={() => {
                  token ? navigate("/messages") : setShowLoginDialog(true);
                  setIsMenuOpen(false);
                }}
                className={`avan-avala-mobile-nav-item cursor-pointer transition-colors text-left py-2 px-4 ${
                  location.pathname.includes("messages")
                    ? "text-orange-500 font-semibold bg-orange-50 rounded-md"
                    : "text-gray-600 hover:text-orange-500"
                }`}
              >
                {t("Messages")}
              </button>

              <button
                onClick={() => {
                  navigate("/subscription");
                  setIsMenuOpen(false);
                }}
                className="avan-avala-mobile-nav-item cursor-pointer transition-colors text-left py-2 px-4 flex items-center text-purple-600  rounded-md
                   text-gray-600 hover:text-purple-600"
              >
                <Crown className="w-4 h-4 mr-2" />
                {t("Subscription")}
              </button>

              {/* Mobile Language Section
              <div className="avan-avala-mobile-language-section pt-4 border-t border-gray-200 px-4">
                <button
                  onClick={changeLanguage}
                  className="avan-avala-mobile-language-btn flex items-center space-x-2 text-gray-600 w-full text-left py-2"
                >
                  <Languages className="w-4 h-4" />
                  <span>
                    {currentLang === "en"
                      ? "Switch to Tamil"
                      : "Switch to English"}
                  </span>
                </button>
              </div> */}

              {/* Mobile Profile Section */}
              {/* {token && profileData && (
                <div className="avan-avala-mobile-profile-section pt-4 border-t border-gray-200 px-4 md:hidden">
                  <div className="flex items-center space-x-3">
                    <div className="flex flex-row justify-between">
                      <span className="text-xs text-gray-500">
                        {subpack === "Elite" ? (
                          <Crown className="w-4 h-4 mr-2 text-purple-500" />
                        ) : subpack === "Premium" ? (
                          <Star className="w-4 h-4 mr-2 text-blue-500" />
                        ) : subpack === "gold" || "premium" ? (
                          <Cannabis className="w-4 h-4 mr-2 text-yellow-500" />
                        ) : (
                          <User className="w-4 h-4 mr-2" />
                        )}
                      </span>
                      <span
                        className="text-sm font-medium text-gray-700 cursor-pointer"
                        onClick={() => {
                          navigate("/profile");
                          setIsMenuOpen(false);
                        }}
                      >
                        {profileData}
                      </span>
                    </div>
                  </div>
                </div>
              )} */}

              {/* Mobile Auth Section */}
              <div className="avan-avala-mobile-auth-section pt-4 border-t border-gray-200 px-4">
                <Button
                  variant={id ? "outline" : "default"}
                  className="bg-gradient-to-br from-red-500 to-pink-600 text-white cursor-pointer"
                  onClick={() => {
                    setIsMenuOpen(!isMenuOpen);
                    if (id) {
                      handleLogout();
                    } else {
                      navigate("/login");
                      setIsMenuOpen(false);
                    }
                  }}
                >
                  {id ? t("Logout") : t("Login")}
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>

      {/* Logout Dialog */}
      <AlertDialog open={showLogoutDialog} onOpenChange={setShowLogoutDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{t("Logout")}</AlertDialogTitle>
            <AlertDialogDescription>
              {t("Are you sure you want to log out?")}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel
              onClick={() => setShowLogoutDialog(false)}
              className="cursor-pointer"
            >
              {t("Cancel")}
            </AlertDialogCancel>
            <AlertDialogAction
              className="bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 cursor-pointer"
              onClick={() => {
                setShowLogoutDialog(false);
                dispatch(clearUserState(null));
                localStorage.removeItem("UserId");
                navigate("/");
              }}
            >
              {t("Logout")}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Login Dialog */}
      <AlertDialog open={showLoginDialog} onOpenChange={setShowLoginDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{t("You're Almost There!")}</AlertDialogTitle>
            <AlertDialogDescription>
              {t("Log in to explore profiles and start connecting")}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel
              onClick={() => setShowLoginDialog(false)}
              className="cursor-pointer"
            >
              {t("Cancel")}
            </AlertDialogCancel>
            <AlertDialogAction
              className="bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 cursor-pointer"
              onClick={() => {
                setShowLoginDialog(false);
                navigate("/login");
              }}
            >
              {t("Login")}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <AlertDialog
        open={openCompletionDialog}
        onOpenChange={setOpenCompletionDialog}
      >
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{t("Your Journey Starts Here")}</AlertDialogTitle>

            <AlertDialogDescription>
              {t(
                "Complete your profile to unlock full access and explore profiles"
              )}
            </AlertDialogDescription>
          </AlertDialogHeader>

          <AlertDialogFooter>
            <AlertDialogCancel
              onClick={() => {
                setOpenCompletionDialog(false);
              }}
              className="cursor-pointer border border-gray-300 hover:bg-gray-100 px-4 py-2 rounded-lg"
            >
              {t("Cancel")}
            </AlertDialogCancel>
            <AlertDialogAction
              className="bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 cursor-pointer"
              onClick={() => {
                setOpenCompletionDialog(false);
                navigate("/profile");
                dispatch(setCurrentPage("profile"));
              }}
            >
              {t("Continue")}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Notification Drawer */}
      {open && (
        <>
          <div
            className="header-notification-backdrop"
            onClick={() => setOpen(false)}
          />
          <div className="header-notification-drawer" ref={dropdownRef}>
            <div className="header-notification-drawer-content">
              {/* Fixed Header */}
              <div className="header-notification-drawer-header">
                <div className="header-notification-drawer-title">
                  <Bell className="header-notification-icon" />
                  <span>{t("Notifications")}</span>
                  {/* {unreadCount > 0 && (
                <span className="header-notification-badge">
                  {unreadCount}
                </span>
              )} */}
                </div>
                <div className="header-notification-drawer-actions">
                  {/* {unreadCount > 0 && (
                <button
                  className="header-mark-all-read-btn"
                  onClick={markAllAsRead}
                >
                  {t("Mark all read")}
                </button>
              )} */}
                  <button
                    className="header-close-drawer-btn"
                    onClick={() => setOpen(false)}
                  >
                    <X className="header-close-icon" />
                  </button>
                </div>
              </div>

              {/* Scrollable Content */}
              <div className="header-notification-drawer-body">
                {notifications.length > 0 ? (
                  <div className="header-notification-list">
                    {notifications.map((notification) => (
                      <div
                        key={notification.id}
                        className={`header-notification-item ${
                          notification.unread
                            ? "header-notification-unread"
                            : ""
                        }`}
                        onClick={() => markAsRead(notification.id)}
                      >
                        <div className="header-notification-item-content">
                          <div className="header-notification-item-header">
                            <p className="header-notification-item-title">
                              {notification.title?.[currentLang]}
                            </p>
                            {notification.unread && (
                              <div className="header-unread-indicator" />
                            )}
                          </div>
                          <p className="header-notification-item-message">
                            {notification.message?.[currentLang]}
                          </p>
                          <div className="header-notification-item-time">
                            <Clock className="header-time-icon" />
                            <span>{notification.time}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="header-notification-empty">
                    <Bell className="header-empty-icon" />
                    <p className="header-empty-title">
                      {t("No notifications yet")}
                    </p>
                    <p className="header-empty-description">
                      {t("We'll notify you when something arrives")}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </header>
  );
});
